import { parsePhoneNumberFromString } from 'libphonenumber-js';
var MIN_PHONE_LENGTH = 3;
export function validatePhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return 'Please enter a phone number.';
  }
  if (phoneNumber.split('').length <= MIN_PHONE_LENGTH) {
    return 'Provided phone number is too short.';
  }
  var parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
  if (!parsedPhoneNumber || parsedPhoneNumber instanceof Error) {
    return 'Please enter a valid phone number.';
  } else {
    if (!parsedPhoneNumber.isPossible()) {
      return 'Invalid phone number for selected country.';
    }
  }
  return true;
}
export function createPhoneInputValidator() {
  return function (value) {
    return validatePhoneNumber(value);
  };
}